import { AutopilotTaskDto, TaskCategoryWorkflowType } from '@urbanx/agx.activities.client';
import { isDepositWorkflowTask } from './taskWorkflow';

export enum TaskTabs {
  Tasks = 'Tasks',
  Deposits = 'Deposits',
  Other = 'Other',
}

export const getTaskTabForTask = (task: AutopilotTaskDto): TaskTabs => {
  const { category } = task;

  if (isDepositWorkflowTask(task)) {
    return TaskTabs.Deposits;
  }

  if (
    category?.workflowType === TaskCategoryWorkflowType.IndependentCampaign ||
    category?.workflowType === TaskCategoryWorkflowType.IndependentContract
  ) {
    return TaskTabs.Other;
  }

  return TaskTabs.Tasks;
};
